import React from 'react';
import {
  Box,
  FormControl,
  NativeSelect,
  Button,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { DigitalCase } from '../../redux/types';

type Props = {
  digitalCases: DigitalCase[];
  selectedCase: number;
  onCaseSelect: (caseId: number) => void;
}

const DigitalCaseNavigator: React.FC<Props> = ({
  digitalCases,
  selectedCase,
  onCaseSelect,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onCaseSelect(Number(event.target.value));
  };

  const handlePrevious = () => {
    const indx = digitalCases.findIndex((dc) => dc.id === selectedCase);
    if (indx > 0) {
      onCaseSelect(digitalCases[indx - 1].id);
    }
  };

  const handleNext = () => {
    const indx = digitalCases.findIndex((dc) => dc.id === selectedCase);
    if (indx < digitalCases.length - 1) {
      onCaseSelect(digitalCases[indx + 1].id);
    }
  };

  return (
    <Box display="flex" justifyContent="center" sx={{ m: 2 }}>
      <Button
        color="tertiary"
        size="small"
        startIcon={<NavigateBeforeIcon />}
        sx={{ mx: '10px' }}
        onClick={handlePrevious}
      >
        previous
      </Button>
      <FormControl sx={{ minWidth: 150 }} size="small" variant="outlined">
        <NativeSelect
          value={selectedCase}
          onChange={handleChange}
        >
          {
            digitalCases.map((dc) => <option key={dc.id} value={dc.id}>{dc.name}</option>)
          }
        </NativeSelect>
      </FormControl>
      <Button
        color="tertiary"
        size="small"
        endIcon={<NavigateNextIcon />}
        sx={{ mx: '10px' }}
        onClick={handleNext}
      >
        Next&nbsp;&nbsp;&nbsp;&nbsp;
      </Button>
    </Box>
  );
};

export default DigitalCaseNavigator;
